import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material';

import { SensorsService } from '../../services/sensors.service';
import { Toaster } from 'ngx-toast-notifications';
import { Sensor } from '../../models/sensor';
import { FormGroup, FormBuilder, FormControl, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import sensorId from '../../helpers/validationMessages/sensor-id';
import sensorLat from '../../helpers/validationMessages/sensorLat';
import sensorLng from '../../helpers/validationMessages/sensorLng';
import sensorSlot from '../../helpers/validationMessages/sensorSlot';
import { GeocodeService } from '../sensors/sensors-list/sensors.geocode.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { Subscription } from 'rxjs';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-new-sensor-dialog',
  templateUrl: './new-sensor-dialog.component.html',
  styleUrls: ['./new-sensor-dialog.component.scss']
})
export class NewSensorDialogComponent implements OnInit, OnDestroy {

  private address: string;

  private geocodeSub$: Subscription;
  private createSensorSub$: Subscription;

  constructor(
    public dialogRef: MatDialogRef<NewSensorDialogComponent>,
    private sensorsService: SensorsService,
    private toaster: Toaster,
    private fb: FormBuilder,
    private geocodingService: GeocodeService) { }

  addSensorForm: FormGroup;

  add_sensor_validation_messages = {
    sensorID: sensorId.sensorID,
    lat: sensorLat.sensorLat,
    lng: sensorLng.sensorLng,
    slot: sensorSlot.sensorSlot
  }

  public sensorID;
  public lat;
  public lng;
  public slot;
  public sensorEdit: Sensor;

  public invalid_data = false;

  private addedSensorData: any;

  public matcher: ErrorStateMatcher;

  ngOnInit() {
    this.createForm()
  }

  createForm() {
    this.addSensorForm = this.fb.group({
      sensor_id: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]+$'),
      ])),
      lat: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]+$'),
        Validators.minLength(9),
        Validators.maxLength(17)
      ])),
      lng: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]+$'),
        Validators.minLength(9),
        Validators.maxLength(17)
      ])),
      slot: new FormControl(undefined, Validators.compose([
        Validators.maxLength(32)
      ]))
    })

    this.matcher = new MyErrorStateMatcher();
  }

  saveSensor() {
    this.getAddress(this.transformLatLongValues(this.addSensorForm.value.lat), this.transformLatLongValues(this.addSensorForm.value.lng))
  }

  private get SensorID(): string {
    return this.addSensorForm.value.sensor_id
  }

  private get Lat(): string {
    return this.addSensorForm.value.lat
  }

  private get Lng(): string {
    return this.addSensorForm.value.lng
  }

  private get Slot(): string {
    return this.addSensorForm.value.slot
  }
  createSensorObject() {
    this.sensorEdit = new Sensor()
    this.sensorEdit.data = {
      type: 'sensor',
      attributes: {
        address: this.address,
        serial: this.SensorID,
        lat: this.transformLatLongValues(this.Lat),
        lng: this.transformLatLongValues(this.Lng),
        name: this.Slot,
      }
    }
    this.submit(this.sensorEdit)
  }

  throwErrorInAddressGeocoding(error?: any) {

    this.toaster.open({
      caption: `Something went wrong when resolving address`,
      text: error,
      type: `warning`,
      duration: 3400
    });
  }

  getAddress(lat: any, lng: any) {
    this.geocodeSub$ = this.geocodingService.geocodeAddress(lat, lng).subscribe(res => {
      this.address = res['address']
      if (this.address == 'N/A address') {
        this.throwErrorInAddressGeocoding('Coordinates could not be resolved, but we put `N/A address` for placeholder')
      }
      this.createSensorObject()
    })
  }

  submit(sensor?: Sensor) {
    this.createSensorSub$ = this.sensorsService.createSensor(sensor).subscribe(
      res => {
        this.addedSensorData = { ...res }
      },
      error => {
        if (Array.isArray(error)) {
          error.forEach(err => {
            this.toaster.open({
              caption: `Error in Adding new Sensor`,
              text: err.detail,
              type: `warning`,
            });
          })
        } else {
          this.toaster.open({
            caption: `Error in Adding new Sensor`,
            text: error.detail,
            type: `warning`,
          });
        }
      },
      () => {
        this.toaster.open({
          caption: `Successfully added sensor`,
          text: `The sensor has been added`,
          type: `success`,
          duration: 1300
        });

        this.dialogRef.close({ "intention": 1 })
      })
  }

  transformLatLongValues(value: string): string {
    const strungValue = value

    let firstTwoStrings = strungValue.substring(0, 2);
    firstTwoStrings = firstTwoStrings + ".";

    const restStrings = strungValue.substring(2, strungValue.length - 1);

    const newStringValue = firstTwoStrings + restStrings;

    return newStringValue;
  }


  cancelProcedure() {
    this.dialogRef.close()

  }

  ngOnDestroy() {
    if (this.geocodeSub$) this.geocodeSub$.unsubscribe();
    if (this.createSensorSub$) this.createSensorSub$.unsubscribe();
  }
}
